<template>
  <svg
    width="182"
    height="136"
    viewBox="0 0 182 136"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="181.001"
      height="39"
      rx="2.53335"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="181.001"
      height="39"
      rx="2.53335"
      stroke="#9333EA"
    />
    <rect
      x="8"
      y="8"
      width="24"
      height="24"
      rx="2"
      fill="#F4F0FA"
    />
    <path
      d="M19.999 15.0908C22.7104 15.0908 24.909 17.2887 24.9092 20C24.9092 22.7115 22.7105 24.9102 19.999 24.9102C17.2878 24.9098 15.0898 22.7113 15.0898 20C15.09 17.2889 17.288 15.0912 19.999 15.0908ZM19.999 15.6592C17.6021 15.6595 15.6584 17.603 15.6582 20C15.6582 22.3971 17.602 24.3405 19.999 24.3408C22.3964 24.3408 24.3398 22.3973 24.3398 20C24.3396 17.6028 22.3962 15.6592 19.999 15.6592ZM20 16.9414C21.6895 16.9417 23.0596 18.3114 23.0596 20.001C23.0592 21.6902 21.6892 23.0603 20 23.0605C18.3105 23.0605 16.9408 21.6903 16.9404 20.001C16.9404 18.3113 18.3103 16.9414 20 16.9414ZM20 17.5098C18.6244 17.5098 17.5088 18.6254 17.5088 20.001C17.5092 21.3762 18.6247 22.4912 20 22.4912C21.3751 22.4909 22.4898 21.3761 22.4902 20.001C22.4902 18.6256 21.3754 17.51 20 17.5098ZM20.001 18.791C20.6687 18.7912 21.2108 19.3323 21.2109 20C21.2109 20.6678 20.6687 21.2098 20.001 21.21C19.3332 21.2098 18.792 20.6678 18.792 20C18.7921 19.3322 19.3332 18.7911 20.001 18.791ZM20.001 19.3594C19.6473 19.3595 19.3605 19.6464 19.3604 20C19.3604 20.3537 19.6473 20.6405 20.001 20.6406C20.3546 20.6404 20.6415 20.3537 20.6416 20C20.6415 19.6464 20.3546 19.3596 20.001 19.3594Z"
      fill="#9333EA"
    />
    <rect
      x="40"
      y="10"
      width="104"
      height="8"
      rx="2"
      fill="#F4F0FA"
    />
    <rect
      x="40"
      y="22"
      width="52"
      height="8"
      rx="2"
      fill="#F4F0FA"
    />
    <rect
      x="0.5"
      y="48.5"
      width="181.001"
      height="39"
      rx="2.53335"
      fill="white"
    />
    <rect
      x="0.5"
      y="48.5"
      width="181.001"
      height="39"
      rx="2.53335"
      stroke="#E7E5E4"
    />
    <path
      d="M8 59.0334C8 57.3581 9.35808 56 11.0334 56H28.9666C30.6419 56 32 57.3581 32 59.0334V76.9666C32 78.6419 30.6419 80 28.9666 80H11.0334C9.35808 80 8 78.6419 8 76.9666V59.0334Z"
      fill="#F5F5F4"
    />
    <path
      d="M19.999 63.0908C22.7104 63.0908 24.909 65.2887 24.9092 68C24.9092 70.7115 22.7105 72.9102 19.999 72.9102C17.2878 72.9098 15.0898 70.7113 15.0898 68C15.09 65.2889 17.288 63.0912 19.999 63.0908ZM19.999 63.6592C17.6021 63.6595 15.6584 65.603 15.6582 68C15.6582 70.3971 17.602 72.3405 19.999 72.3408C22.3964 72.3408 24.3398 70.3973 24.3398 68C24.3396 65.6028 22.3962 63.6592 19.999 63.6592ZM20 64.9414C21.6895 64.9417 23.0596 66.3114 23.0596 68.001C23.0592 69.6902 21.6892 71.0603 20 71.0605C18.3105 71.0605 16.9408 69.6903 16.9404 68.001C16.9404 66.3113 18.3103 64.9414 20 64.9414ZM20 65.5098C18.6244 65.5098 17.5088 66.6254 17.5088 68.001C17.5092 69.3762 18.6247 70.4912 20 70.4912C21.3751 70.4909 22.4898 69.3761 22.4902 68.001C22.4902 66.6256 21.3754 65.51 20 65.5098ZM20.001 66.791C20.6687 66.7912 21.2108 67.3323 21.2109 68C21.2109 68.6678 20.6687 69.2098 20.001 69.21C19.3332 69.2098 18.792 68.6678 18.792 68C18.7921 67.3322 19.3332 66.7911 20.001 66.791ZM20.001 67.3594C19.6473 67.3595 19.3605 67.6464 19.3604 68C19.3604 68.3537 19.6473 68.6405 20.001 68.6406C20.3546 68.6404 20.6415 68.3537 20.6416 68C20.6415 67.6464 20.3546 67.3596 20.001 67.3594Z"
      fill="#505050"
    />
    <rect
      x="40"
      y="58"
      width="104"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      x="40"
      y="70"
      width="52"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      x="0.5"
      y="96.5"
      width="181.001"
      height="39"
      rx="2.53335"
      fill="white"
    />
    <rect
      x="0.5"
      y="96.5"
      width="181.001"
      height="39"
      rx="2.53335"
      stroke="#E7E5E4"
    />
    <path
      d="M8 107.033C8 105.358 9.35808 104 11.0334 104H28.9666C30.6419 104 32 105.358 32 107.033V124.967C32 126.642 30.6419 128 28.9666 128H11.0334C9.35808 128 8 126.642 8 124.967V107.033Z"
      fill="#F5F5F4"
    />
    <path
      d="M19.999 111.091C22.7104 111.091 24.909 113.289 24.9092 116C24.9092 118.711 22.7105 120.91 19.999 120.91C17.2878 120.91 15.0898 118.711 15.0898 116C15.09 113.289 17.288 111.091 19.999 111.091ZM19.999 111.659C17.6021 111.66 15.6584 113.603 15.6582 116C15.6582 118.397 17.602 120.34 19.999 120.341C22.3964 120.341 24.3398 118.397 24.3398 116C24.3396 113.603 22.3962 111.659 19.999 111.659ZM20 112.941C21.6895 112.942 23.0596 114.311 23.0596 116.001C23.0592 117.69 21.6892 119.06 20 119.061C18.3105 119.061 16.9408 117.69 16.9404 116.001C16.9404 114.311 18.3103 112.941 20 112.941ZM20 113.51C18.6244 113.51 17.5088 114.625 17.5088 116.001C17.5092 117.376 18.6247 118.491 20 118.491C21.3751 118.491 22.4898 117.376 22.4902 116.001C22.4902 114.626 21.3754 113.51 20 113.51ZM20.001 114.791C20.6687 114.791 21.2108 115.332 21.2109 116C21.2109 116.668 20.6687 117.21 20.001 117.21C19.3332 117.21 18.792 116.668 18.792 116C18.7921 115.332 19.3332 114.791 20.001 114.791ZM20.001 115.359C19.6473 115.359 19.3605 115.646 19.3604 116C19.3604 116.354 19.6473 116.641 20.001 116.641C20.3546 116.64 20.6415 116.354 20.6416 116C20.6415 115.646 20.3546 115.36 20.001 115.359Z"
      fill="#505050"
    />
    <rect
      x="40"
      y="106"
      width="104"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      x="40"
      y="118"
      width="52"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      y="48"
      width="182"
      height="88"
      fill="url(#paint0_linear_40_11167)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_40_11167"
        x1="91"
        y1="48"
        x2="91"
        y2="136"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="white"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="white"
        />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
</script>
